import { Injectable, inject } from '@angular/core';
import { User } from '@compumark/order-management-client';
import { filter, first } from 'rxjs/operators';
import { OtiService } from 'src/oti-snippet/oti-wrapper';

import { environment } from '../../../environments/environment';

import { UserService } from './user.service';

@Injectable()
export class AnalyticsService {
  private userService = inject(UserService);

  private appName = 'watch-order-management';

  async init(): Promise<void> {
    if (environment.pendo.enabled) {
      const user = (await this.userService
        .getCurrentUserObservable()
        .pipe(
          filter((u) => !!u.id),
          first(),
        )
        .toPromise()) as User;

      const otiService = new OtiService();
      otiService.initialize({
        app_id: this.appName,
        ot_key: environment.oneTrust.apiKey,
        zendesk_key: environment.zendesk.apiKey,
        zendesk_appName: this.appName,
        zendesk_environment: environment.zendesk.environment,
        zendesk_access_domain: environment.backendBaseUrl,
        zendesk_hide_article_link: true,
        prod_domain: environment.oneTrust.productionUrl,
        pendo_key: environment.pendo.apiKey,
        pendo_url: `https://content.usage.apps.compumark.com/agent/static/${environment.pendo.apiKey}/pendo.js`,
        pendo_visitor_url:
          environment.backendBaseUrl + '/pendo/visitor/agent/value?create=true',
        pendo_dnp_url:
          environment.backendBaseUrl +
          `/pendo/visitor/pendo/value/${user.id}/donotprocess`,
        pendo_metadata_url:
          environment.backendBaseUrl +
          `/pendo/visitor/custom/value/${user.id}/APPID_targetingcookies`,
        request_with_credentials: true,
        pendo_details: {
          visitor: {
            id: user.id,
            name: user.name,
            email: user.email,
          },
          account: {
            id: 'wdt',
          },
        },
        pendo_visitor_payload: [
          {
            visitorId: user.id,
            values: { name: user.name, email: user.email },
          },
        ],
      });
    }
  }
}
